import { doc, getDoc, getFirestore } from "firebase/firestore";

import { AppAuth } from "../../../apps/offline.ct.gt/auth/app-auth.js";
import { users_offline } from "../../../apps/offline.ct.gt/models/offline.schema.js";
import { ITestPending } from "../../../tests/models/test-pending";
import { HighPerformance } from "../../../tests/response/high-performance/high-performance.js";
import { IInitialStatePerformTest, IStatePerformTestPut } from "../../../tests/response/models/initial-state-test-response";
import { IPagination } from "../../v2/Fetch";
import { xFetch } from "../../v2/Fetchv2.js";
import { FSSchema } from "../../v2/schemas/fs.schema.js";
import { MGSchema, TestQuestion, tests_complete } from "../../v2/schemas/mg.schema.js";
import { v3get, v3http } from "../Fetchv3";

export class Test {
	async getServerTimestamp() {
		if (HighPerformance.getInstance().mode == "offline") return Date.ts();
		const [tsup, error] = await v3get<{ ts: number }>(`/ts`);
		if (error) {
			return Date.ts();
		}
		return tsup.ts;
	}

	async getUserTests(params?: { complete?: boolean; pgid?: string; tid?: number } & IPagination) {
		let response = await v3http<ITestPending>(`/users/me/tests?unix=${Date.now()}`, "POST", params);
		return response;
	}

	/** Este metodo se llama cuando se inicia una prueba o cuando se omite una pregunta y se necesita calcular cual es la siguiente pregunta */
	async getTestComplete(pgid: string, _id: string, tid: number, v: number, params?: IPagination): Promise<[IInitialStatePerformTest | undefined, xFetch.xError<null> | undefined]> {
		if (_id.startsWith("~")) {
			let hp = HighPerformance.getInstance();
			let test_complete: tests_complete;
			if (hp.mode == "firestore") {
				if (window.app.localStorage.currentTest?._id == _id) {
					console.log("currentTest", window.app.localStorage.currentTest);
					let [rsp, err] = await hp.getTestComplete(window.app.localStorage.currentTest, window.app.localStorage.currentTest);
					return [rsp, err];
				} else {
					let docRef = doc(getFirestore(), FSSchema.collections.assessments, _id);
					const [docSnap, err] = await getDoc<tests_complete, {}>(docRef as any).go();
					// Se hace de esta forma ya que si el test no existe en firestore, se debe buscar en el servidor
					if (err == null && docSnap.exists()) {
						test_complete = docSnap.data();
						try {
							let [prefRsp, err] = await this.getTestCompletePreferences(pgid, _id, tid, v);
							if (err == null && prefRsp) {
								let firestorePref = test_complete.preferences?.sort((a, b) => a - b);
								let pref = prefRsp.preferences?.sort((a, b) => a - b);
								if (firestorePref && pref && JSON.stringify(firestorePref) != JSON.stringify(pref)) {
									test_complete.preferences = pref;
									console.log("UPDATE PREF");
								}
								if (prefRsp.group) {
									test_complete.group = prefRsp.group;
									console.log("UPDATE group");
								}
								if (prefRsp.schedule) {
									test_complete.schedule = prefRsp.schedule;
									console.log("UPDATE schedule");
								}
								if (prefRsp.limit_time) {
									test_complete.limit_time = prefRsp.limit_time;
									console.log("UPDATE limit_time");
								}
								if (prefRsp.blur_limit) {
									test_complete.blur_limit = prefRsp.blur_limit;
									console.log("UPDATE blur_limit");
								}
							}
						} catch (e) {
							console.log(e);
						}
						window.app.localStorage.currentTest = test_complete;
						let [rsp, errGetTest] = await hp.getTestComplete(test_complete, test_complete);
						return [rsp, errGetTest];
					}
				}
			} else if (hp.mode == "offline") {
				debugger;
				let allTests: MGSchema.tests[] = await fetch("/static/json/offline/ALL_TESTS.json").then(r => r.json());
				// Cargo los usuarios para asignar
				let allUsers: users_offline[] = await fetch("/static/json/offline/USERS.json").then(r => r.json());
				let user = allUsers.find(u => u.uid == AppAuth.getInstace().getUser()?.sub);
				let test = allTests.find((t: any) => t.tid == tid);
				if (window.app.localStorage.currentTest?._id == _id) {
					console.log("currentTest", window.app.localStorage.currentTest);
					let [rsp, err] = await hp.getTestComplete(window.app.localStorage.currentTest, test!);
					return [rsp, err];
				}
				test_complete = hp.toTestComplete(test!, user!);
				window.app.localStorage.currentTest = test_complete;
				let [rsp, err] = await hp.getTestComplete(test_complete, test!);
				console.log("next_question", rsp?.next_question);
				return [rsp, err];
			}
		}
		const [json, error] = await v3http<IInitialStatePerformTest>(`/users/me/tests/${_id}?unix=${Date.now()}`, "POST", { pgid, tid, v, ...params });
		return [json, error];
	}

	async getTestCompletePreferences(pgid: string, _id: string, tid: number, v: number, params?: IPagination) {
		const rsp = await v3http<Pick<tests_complete, "preferences" | "schedule" | "tags" | "limit_time" | "blur_limit" | "group">>(`/users/me/tests/${_id}/preferences?unix=${Date.now()}`, "POST", {
			pgid,
			tid,
			v,
			...params
		});
		return rsp;
	}

	async SendPing(pgid: string, _id: string, tid: number, v: number, params?: IPagination) {
		const rsp = await v3http<Pick<tests_complete, "preferences" | "schedule" | "tags" | "limit_time" | "blur_limit" | "group">>(`/users/me/tests/${_id}/ping`, "POST", {
			pgid,
			tid,
			v,
			...params
		});
		return rsp;
	}

	async setAnswersOnQuestion(pgid: string, _id: string, tid: number, v: number, params: TestQuestion): Promise<[IStatePerformTestPut, xFetch.xError<null> | undefined]> {
		let hp = HighPerformance.getInstance();
		if (_id.startsWith("~") && hp.testComplete != null) {
			return hp.t0EvalNormal({ questionAnswered: params });
		} else {
			const [rsp, err] = await v3http<IStatePerformTestPut>(`/users/me/tests/${_id}?unix=${Date.now()}`, "PUT", { params, tid, pgid, v });
			return [rsp, err];
		}
	}
}
